import { MakeBackendRequest } from "./MakeBackendRequest";

export const fetchFaqs = async () => {
  try {
    const response = await MakeBackendRequest({
      urlSuffix: `/api/v1/faqs`,
      method: "get",
      data: {},
    });

    return response.data;
  } catch (error) {
    throw error.response;
  }
};
